import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { Organization, CreateOrganizationInput } from '../types/organization.type';
import { ADMIN_ORGANIZATIONS_API_PATHS } from '../constants/organizations-paths.constants';

type UseCreateOrganizationResult = {
  createOrganization: (input: CreateOrganizationInput) => Promise<Organization | null>;
  isCreating: boolean;
};

export function useCreateOrganization(): UseCreateOrganizationResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isCreating, setIsCreating] = useState(false);

  const createOrganization = async (input: CreateOrganizationInput): Promise<Organization | null> => {
    setIsCreating(true);

    try {
      const createdOrganization = await HttpClient.post<Organization>(
        ADMIN_ORGANIZATIONS_API_PATHS.CREATE_ORGANIZATION,
        input
      );

      enqueueSnackbar("L'organisation a été créée avec succès", { variant: 'success' });
      return createdOrganization;
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(error, "Une erreur est survenue lors de la création de l'organisation"),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsCreating(false);
    }
  };

  return { createOrganization, isCreating };
}
